(function () {
  var root = document.querySelector(".vp-landing-shell");
  if (!root) return;

  // --- Essential interactions: must work on EVERY device and regardless of
  // motion preferences. These are wired up first, before the guards below that
  // skip the optional scroll animations. (Previously the video play button was
  // inside the GSAP init, so it was dead on phones and for reduced-motion users
  // who never reached that code.)
  root.querySelectorAll("[data-vp-video-play]").forEach(function (button) {
    button.addEventListener("click", function () {
      var frame = button.closest("[data-vp-video-frame]");
      var video = frame && frame.querySelector("video");
      if (!frame || !video) return;

      frame.classList.add("vp-video-frame--is-playing");

      // Make sure the native controls are available even if scripted playback
      // is blocked, so the visitor is never left with a frame that won't start.
      video.setAttribute("controls", "");

      var played = video.play();
      if (played && typeof played.catch === "function") {
        played.catch(function () {
          video.focus();
        });
      }
    });
  });

  // --- Optional enhancement below: GSAP scroll-reveal animations. Skipped when
  // the visitor prefers reduced motion, and on phones where the scroll listener
  // made scrolling stutter. The page stays fully visible and usable without it.
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (window.matchMedia("(max-width: 768px)").matches) return;

  var loadScript = function (src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
        if (existing.dataset.loaded === "true") resolve();
        return;
      }

      var script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.onload = function () {
        script.dataset.loaded = "true";
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  var init = function () {
    if (!window.gsap || !window.ScrollTrigger) return;

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    gsap.set(root.querySelectorAll(".vp-landing-section, .vp-landing-logos, .vp-landing-guarantee-band, .vp-landing-final"), {
      autoAlpha: 0,
      y: 22
    });

    window.ScrollTrigger.batch(root.querySelectorAll(".vp-landing-section, .vp-landing-logos, .vp-landing-guarantee-band, .vp-landing-final"), {
      start: "top 82%",
      once: true,
      onEnter: function (items) {
        gsap.to(items, {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          ease: "power2.out",
          stagger: 0.08
        });
      }
    });

    window.ScrollTrigger.batch(root.querySelectorAll(".vp-landing-proof-strip article, .vp-landing-step, .vp-landing-faq article, .vp-landing-testimonial, .vp-landing-testimonial-video"), {
      start: "top 86%",
      once: true,
      onEnter: function (items) {
        gsap.from(items, {
          autoAlpha: 0,
          y: 16,
          duration: 0.55,
          ease: "power2.out",
          stagger: 0.07
        });
      }
    });

    root.querySelectorAll(".vp-landing-primary, .vp-landing-secondary").forEach(function (button) {
      button.addEventListener("mouseenter", function () {
        gsap.to(button, { scale: 1.025, duration: 0.18, ease: "power2.out" });
      });

      button.addEventListener("mouseleave", function () {
        gsap.to(button, { scale: 1, duration: 0.2, ease: "power2.out" });
      });
    });
  };

  (window.gsap ? Promise.resolve() : loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js"))
    .then(function () {
      return window.ScrollTrigger ? Promise.resolve() : loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js");
    })
    .then(init)
    .catch(function () {
      root.classList.add("vp-landing-no-motion");
    });
})();
